import React, { useEffect } from 'react';

const SEO = ({ 
  title = "Qivra Technologies - AI & IT Solutions", 
  description = "Qivra Technologies delivers cutting-edge AI and IT solutions, from machine learning to cloud transformation. Transform your business with our expert team.", 
  keywords = "AI, Machine Learning, Cloud Computing, Digital Transformation, IT Consulting, Software Development, Cybersecurity, Qivra Technologies",
  image = "/logo512.png",
  url = "https://www.qivratech.com",
  type = "website"
}) => {
  
  useEffect(() => {
    // Update document title
    document.title = title;
    
    // Update meta tags
    const updateMetaTag = (name, content, property = false) => {
      const selector = property ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let tag = document.querySelector(selector);
      
      if (!tag) {
        tag = document.createElement('meta');
        if (property) {
          tag.setAttribute('property', name);
        } else {
          tag.setAttribute('name', name);
        }
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };

    // Primary meta tags
    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);
    updateMetaTag('robots', 'index, follow');
    
    // Open Graph tags
    updateMetaTag('og:type', type, true);
    updateMetaTag('og:url', url, true);
    updateMetaTag('og:title', title, true);
    updateMetaTag('og:description', description, true);
    updateMetaTag('og:image', image, true);
    
    // Twitter tags
    updateMetaTag('twitter:card', 'summary_large_image', true);
    updateMetaTag('twitter:url', url, true);
    updateMetaTag('twitter:title', title, true);
    updateMetaTag('twitter:description', description, true);
    updateMetaTag('twitter:image', image, true);

    // Schema.org structured data
    let schemaScript = document.querySelector('#schema-org-data');
    if (!schemaScript) {
      schemaScript = document.createElement('script');
      schemaScript.id = 'schema-org-data';
      schemaScript.type = 'application/ld+json';
      document.head.appendChild(schemaScript);
    }
    
    schemaScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Qivra Technologies",
      "url": "https://www.qivratech.com",
      "logo": "https://www.qivratech.com/logo512.png",
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+1-555-123-4567",
        "contactType": "customer service",
        "email": "contact@qivratech.com"
      },
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "123 Tech Street, Suite 500",
        "addressLocality": "San Francisco",
        "addressRegion": "CA",
        "postalCode": "94105",
        "addressCountry": "US"
      },
      "sameAs": [
        "https://www.linkedin.com/company/qivratech",
        "https://twitter.com/qivratech",
        "https://github.com/qivratech"
      ],
      "description": "Qivra Technologies delivers cutting-edge AI and IT solutions, specializing in machine learning, cloud computing, and digital transformation services."
    });
  }, [title, description, keywords, image, url, type]);

  return (
    <></>
  );
};

export default SEO;